// extracted by mini-css-extract-plugin
export default {"attachments":"AssignmentFormModal_attachments__+Svh7","attachmentItems":"AssignmentFormModal_attachmentItems__6djRV"};